import { render, staticRenderFns } from "./NewApplicantDialog.vue?vue&type=template&id=00f64d3e&"
import script from "./NewApplicantDialog.vue?vue&type=script&lang=js&"
export * from "./NewApplicantDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports